<template>
  <div class="columns is-multiline">
    <div
      v-for="(module, index) in Object.keys(value)"
      :key="index"
      class="column is-3"
    >
      <b-field>
        <b-input readonly :value="$t(module)" />
        <p class="control">
          <b-colorpicker
            :disabled="!modules.includes(module)"
            @input="(color) => updateColor(color, module)"
            :value="buffer[module]"
          />
        </p>
      </b-field>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Modules from '@/models/Modules.js'
import { useCoreStore } from '@/stores/core.js'

export default {
  name: 'ModulesColors',
  inject: ['$validator'],
  props: {
    value: Object
  },
  setup () {
    const coreStore = useCoreStore()
    return { coreStore }
  },
  data () {
    return {
      buffer: Object.assign({}, this.value)
    }
  },
  computed: {
    modules: function () {
      return this.coreStore.activeModules(true)
    }
  },
  methods: {
    updateColor (color, module) {
      this.buffer[module] = color.toString('hex')
      this.$emit('input', this.buffer)
    }
  },
  watch: {
    value: {
      handler () {
        this.buffer = Object.assign({}, this.value)
      },
      deep: true
    }
  },
  mounted () {
    // add active module not already set
    for (let module of this.modules) {
      if (!Object.keys(this.value).includes(module)) {
        Vue.set(this.value, module, Modules.DEFAULT_COLORS[module])
      }
    }
  }
}
</script>
